import React from 'react';
import { styled } from 'linaria/react';

import { theme } from '../Theme';

export const ColumnWrapper = styled('div')`
  position: relative;
  height: 100%;
  display: block;
  flex-wrap: wrap;
  align-items: center;
  ${theme.below.lg} {
    width: 100%;
  }

  &.maxWidth {
    margin: auto;
    width: 100%;
    min-width: 0;
    max-width: ${props => props.maxWidth};
    ${theme.below.lg} {
      padding: 0 10px;
    }
  }
`;

const Column = ({ children, maxWidth }) => (
  <ColumnWrapper
    className={maxWidth ? 'maxWidth' : null}
    maxWidth={maxWidth ? maxWidth : null}
  >
    {children}
  </ColumnWrapper>
);

export default Column;
